// extracted by mini-css-extract-plugin
export default {"schedule":"info_schedule__LXa83","features":"info_features__+QLUK","item":"info_item__WmzLx"};